'use client';

import Link from 'next/link';
import { Heart } from 'lucide-react';
import { useBasePath } from '../navigation/base-path';
import { S3Image } from './s3-image';
import { VideoThumbnail } from './video-thumbnail';

export interface ProfileGalleryItem {
  id: string;
  resultUrl: string | null;
  thumbnailUrl: string | null;
  resultType: 'IMAGE' | 'VIDEO' | 'AUDIO';
  prompt: string | null;
  likesCount: number;
}

interface ProfilePublicationsGridProps {
  posts?: ProfileGalleryItem[];
}

export function ProfilePublicationsGrid({
  posts,
}: ProfilePublicationsGridProps) {
  const basePath = useBasePath();

  if (!posts || posts.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center px-4 py-12 text-center">
        <p className="text-[#8e8e93]">Нет публикаций</p>
        <p className="mt-1 text-sm text-[#8e8e93]/70">
          Создайте генерацию и опубликуйте её
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3">
      {posts.map((post) => (
        <Link
          key={post.id}
          href={`${basePath}/history/${post.id}?source=publications`}
          className="relative aspect-square overflow-hidden bg-card"
        >
          {post.resultUrl &&
            (post.resultType === 'VIDEO' ? (
              <VideoThumbnail
                src={post.resultUrl}
                poster={post.thumbnailUrl}
                alt={post.prompt || 'Video'}
                iconSize="lg"
              />
            ) : (
              <S3Image
                src={post.thumbnailUrl || post.resultUrl}
                alt={post.prompt || ''}
                fill
                className="object-cover"
              />
            ))}
          {post.likesCount > 0 && (
            <div className="absolute bottom-2 left-2 flex items-center gap-1 rounded-full bg-black/40 px-2 py-1">
              <Heart className="h-3 w-3 fill-red-500 text-red-500" />
              <span className="text-xs text-white">{post.likesCount}</span>
            </div>
          )}
        </Link>
      ))}
    </div>
  );
}
